
<div id="main-wrapper">
  <div class="site-wrapper-reveal">
      <div class="position-relative w-100">
          <div class="d-flex align-items-center w-100">

              <!-- "> md" -->
              <img src="../../../assets/images/banners/Artboardsalesforce.png"
                  class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="manufacturing-banner" />

              <!-- "<= md" -->
              <img src="../../../assets/images/banners/Artboardsalesforcemobile.png"
                  class="img img-responsive d-block d-md-none" width="100%" alt="manufacture-mobile-banner" />

              <div class="position-absolute w-100 home-banner">
                  <div class="row h-100 w-100">
                      <div class="col-9 col-md-5 col-sm-12 col-xs-12 col-lg-5 banner-section">

                          <div class="align-items-center banner-content-title  global_title global_banner_title"
                              role="heading" aria-level="1">
                              <span>How a Global Maritime Leader Modernized Customer Support Using Salesforce</span>

                          </div>
                        
                        
                      </div>
                  </div>
              </div>
          </div>
      </div>

  </div>
</div>
<!--============ Banner End ============-->
<div id="primary" class="content-area">
  <main id="main" class="site-main">
    <div class="buttons_colour">
      <div class="container-fluid">
        <div class="btn-group">
          <a (click)="scrollToSection('projectPreview')" class="btn" role="button">Project Preview</a>
          <a (click)="scrollToSection('businessChallenge')" class="btn" role="button">Business Challenge</a>
          <a (click)="scrollToSection('ourSolution')" class="btn" role="button">Our Solution</a>
          <a (click)="scrollToSection('resultsResolved')" class="btn" role="button">Results& Resolved Challenges</a>
        </div>
      </div>
    </div>
  </main>
</div>
<section class=" py-5 bg-light" id="projectPreview">
  <div class="container ">

    <div class="text-center h2 mb-4 fw-fold">Project Preview</div>
    <p class="text-center mb-5 hiringSec">LISCR, one of the world’s largest ship registries, was facing operational
      inefficiencies due to fragmented customer support workflows. Queries were routed through individual inboxes,
      handled manually across departments, and lacked visibility or tracking.</p>
    <p class="text-center mb-5 hiringSec">Maganti IT Resources was engaged to implement a Salesforce-based Email2Case
      solution that would bring structure, speed, and scalability to LISCR’s support operations—enabling centralized
      communication, real-time analytics, and full organizational adoption without added license costs. </p>
  </div>
</section>
<section class="consulting-section py-5 bg-white" id="businessChallenge">
  <div class="container">
    <div class="row align-items-stretch">
      <div class="col-lg-8 d-flex flex-column justify-content-center px-5">
        <div class="h4 mb-4 fw-bold">Business Challenge </div>
        <p class="mb-4 ">Prior to implementation, LISCR faced several operational bottlenecks: </p>

        <ul class="list-unstyled ">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Disconnected departmental workflows.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Delayed issue resolution due to manual email routing.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Limited visibility into performance metrics.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Underutilization of Salesforce beyond one department.
          </li>
        </ul>
        <p class="mb-4 ">They needed a centralized platform that would enable cross-team collaboration, improve response
          times, and provide leadership with clear visibility into service delivery. </p>

      </div>
      <div class="col-lg-4  d-flex p-0">

        <img src="../../../assets/images/staffing/technology-It-staffing/salesforces1.jpg" alt="Consulting Services"
          class="w-100 h-100 object-fit-cover rounded-start" style="object-fit: cover;">
      </div>
    </div>
  </div>
</section>
<section class="solutions-section bg-light py-5" id="ourSolution">
  <div class="container">
    <div class="row align-items-stretch">
      <div class="col-lg-4 d-flex p-0">
        <img src="../../../assets/images/staffing/technology-It-staffing/salesforce2.jpg" alt="Leadership Hiring"
          class="w-100 h-100 object-fit-cover rounded-start" style="object-fit: cover;">
      </div>
      <div class="col-lg-8  d-flex flex-column justify-content-center ps-5 pe-2 ">
        <div class="h4 mb-4 fw-bold">Our Solution </div>
        <p class="mb-4 ">Maganti IT Resources designed and implemented a custom <b> Salesforce Email2Case solution,</b>
          tailored to LISCR’s multi-departmental environment. This included:
          process.</p>

        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Enabling shared departmental inboxes with automatic case generation.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Developing <b>custom Lightning Web Components (LWC)</b> for email handling
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Building <b>real-time dashboards </b>to track performance and response times
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Implementing <b>REST API integrations</b> for system-to-system communication.
          </li>

          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Creating <b>role-based access controls</b> to ensure secure, targeted visibility.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Reducing licensing costs through <b>code-based access configurations </b>
          </li>
        </ul>
        <p class="mb-4 ">The result was a unified, efficient case management system that delivered clear business value.
        </p>
      </div>
    </div>
  </div>
</section>
<section class="py-5 bg-white" id="industrieServe">
  <div class="container">
    <h2 class="text-center section-title">Results & Resolved Challenges</h2>
    <div class="text-center h2 mb-4">The solution significantly improved LISCR’s service operations: </div>
    <div class="row g-4 justify-content-center ">
      <div class="col-md-4">
        <div class="feature-card">
          <h3>Before Implementation </h3>
          <ul>
            <li>Limited Salesforce usage (only Marketing). </li>
            <li>Manual query handling via email. </li>
            <li>No centralized performance tracking.</li>
            <li>Rising license costs.</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div class="feature-card">
          <h3>After Implementation </h3>
          <ul>
            <li> Salesforce adopted across all onshore departments. </li>
            <li>Automated case creation and assignment via Email2Case.</li>
            <li>Live dashboards with real-time performance metrics. </li>
            <li>License optimization through code-level access configuration. </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class=" py-5 bg-light">
  <div class="container ">
    <div class="h2 mb-4 fw-fold text-center">Challenges We Solved </div>
    <ul class="list-unstyled px-5 mx-auto justify-center-list">
      <li class="mb-3">
        <i class="bi bi-check-circle-fill text-primary me-2"></i>
        <strong>Evolving requirements:</strong> Managed through ongoing collaboration and agile delivery cycles.
      </li>
      <li class="mb-3">
        <i class="bi bi-check-circle-fill text-primary me-2"></i>
        <strong>Departmental workflow conflicts:</strong> Addressed via custom flows tailored to each team
      </li>
      <li class="mb-3">
        <i class="bi bi-check-circle-fill text-primary me-2"></i>
        <strong>Role-specific visibility issues:</strong> Solved using secure Apex and LWC-based access logic
      </li>
    </ul>
  </div>
</section>
<section class="solutions-section py-5 bg-white">
  <div class="container">
    <div class="row align-items-stretch" style="min-height: 100%;">
      <div class="col-lg-4 d-flex p-0">
        <img src="../../../assets/images/staffing/technology-It-staffing/group-young-business-people-working-office.jpg"
          alt="Creative Teams" class="w-100 h-100 object-fit-cover rounded-start" style="object-fit: cover;">
      </div>
      <div class="col-lg-8 d-flex flex-column justify-content-center px-5 ">
        <div class="h2 mb-4 hiringblocks">Why Maganti IT Resources? </div>
        <p class="mb-4 "> Maganti IT Resources combines deep Salesforce expertise with a solution-first mindset. Instead
          of relying solely on out-of-the-box tools, we build tailored systems that align with real-world operations.
        </p>
        <ul class="custom-list">
          <li> 6+ years of Salesforce development and implementation experience. </li>
          <li>Certified developers with cross-industry case management expertise.</li>
          <li>Agile execution model with a focus on cost, speed, and usability. </li>
          <li>Consistent client collaboration and proactive problem-solving.</li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section class="solutions-section py-5 bg-light">
  <div class="container">
    <div class="row align-items-stretch" style="min-height: 100%;">
      <div class="col-lg-8 d-flex flex-column justify-content-center px-5 ">
        <div class="h2 mb-4 hiringblocks">Ready to Modernize Your Case Management Strategy? </div>
        <p class="mb-4 "> If your organization is managing support workflows through disconnected systems—or struggling
          with slow response times and poor visibility—we can help. </p>
        <p class="mb-4"><strong>Let’s talk.</strong></p>
        <p class=" mb-4 "> Book a discovery call or request a live demo tailored to your industry needs. </p>
      </div>
      <div class="col-lg-4 d-flex p-0">
        <img src="../../../assets/images/staffing/technology-It-staffing/social-integration-working-team.jpg"
          alt="Creative Teams" class="w-100 h-100 object-fit-cover rounded-start" style="object-fit: cover;">
      </div>
    </div>  
  </div>
</section>